/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { Typography } from "@mui/material";

const DocumentArchiveDialogPanel = (props) => {
    
    const { selectedDocument } = props;
    const { url, title, file_name } = selectedDocument || {};
    
    return (
        <Fragment>
            <div className='image-delete-container'>
                <Typography variant="body1" mt={3}>
                    Please confirm you want to archive this document from the SimpliCity Digital Assets
                    Document Library.
                </Typography>
                <div style={{ fontWeight: "700" }}>
                    {title}
                </div>
                <div style={{ fontWeight: "700" }}>
                    <a href={url} target='_blank'>
                        {file_name}
                    </a>
                </div>
                <Typography variant="body1" mt={3}>
                    Archiving is a &apos;soft-delete&apos;. Archiving a document causes the document to be
                    removed from public use, and will no longer be visible here in the SimpliCity Document Library,
                    unless you explicitly search for archived documents.
                </Typography>
                <Typography variant="body1" mt={3}>
                    Archiving a document does not yet alter any existing placements for the document.
                    These relationships would need to be removed before archiving, and later re-established
                    if you restore the document.
                    {/*Archiving a document disconnects*/}
                    {/*any relationships it has, where it was placed into content. These relationships would need*/}
                    {/*to be re-established, if you later restore the document.*/}
                </Typography>
                <Typography variant="body1" mt={3}>
                    Archived documents are physically moved to a secondary document archive library when
                    they are archived.
                </Typography>
            </div>
        </Fragment>
    );
};

export { DocumentArchiveDialogPanel };
